<template>
  <div id="chartSHMFrame">
    <div class="chartWrapper" id="chartWrapper">
      <div v-if="loaded == false">
        <p style="padding-top: 70px">
          <center>
            <div class="fa-3x">
              <i class="fas fa-spinner fa-spin"></i>
            </div>
            Cargando datos
          </center>
        </p>
      </div>
      <apexchart
        ref="chartshm"
        v-if="loaded"
        width="800"
        height="200"
        type="bar"
        :options="chartOptions"
        :series="series"
      ></apexchart>
    </div>
  </div>
</template>


<script>
import GroupService from "@/services/GroupService";

export default {
  name: "shm-chart",
  data() {
    return {
      loaded: false,
      datacollection: {
        agrupacion: "",
        fecha: "",
      },
      series: [],
      chartOptions: {
        chart: {
          type: "bar",
          height: 150,
          toolbar: {
            show: false,
          },
        },
        title: {
          text: undefined,
          align: "center",
          margin: 10,
          offsetX: 0,
          offsetY: 0,
          floating: false,
          style: {
            fontSize: "13px",
            fontWeight: "bold",
            fontFamily: undefined,
            color: "#263238",
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 3,
          colors: ["transparent"],
        },
        xaxis: {
          categories: [
            "Freq 1",
            "Freq 2",
            "Freq 3",
            "Freq 4",
            "Freq 5",
            "Freq 6",
            "Freq 7",
            "Freq 8",
          ],
        },
        yaxis: {
          title: {
            text: "Hercios (Hz)",
          },
        },
        fill: {
          opacity: 1,
        },
        legend: {
          show: false,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return "" + val + " Hz";
            },
          },
        },
      },
    };
  },


  methods: {
   async retrieveChartSHM(id, arrayPos) {
      this.loaded = false;

      if (id){
        await GroupService.getSHM(id, arrayPos)
          .then((response) => {
            if (response.data && response.data.series && response.data.fecha) {
              this.series = response.data.series;
              this.chartOptions.title.text = response.data.fecha
            } else {
              this.series = []
            }
            
            this.loaded = true;
            //this.scroll2section("chartWrapper");
          })
          .catch((e) => {
            this.loaded = true;
            console.log("Error recuperando datos de la grafica");
            console.log(e)
          });
      } else {
        this.series = [];
        this.loaded = true;
      }
    },

    scroll2section(id) {
      window.scrollTo(0, 950);
    },
  },
};
</script>

<style scoped>
.titulo {
  position: absolute;
  margin-top: -55px;
  margin-left: 310px;
  font-size: 0.95rem;
  color: #606266;
  text-align: center;
  font-weight: 400;
}

.agrupacionTitulo {
  font-weight: 500;
}

.fecha {
  margin-top: 20px;
  margin-bottom: 20px;
  margin-left: 20px;
  font-size: 0.8rem;
  color: #606266;
}

.fechaTitulo {
  margin-left: 30px;
  font-weight: 500;
}

.chartWrapper {
  margin-top: 10px;
  height: 100px;
}
#measureChartFrame {
  width: 100%;
}

.toolbar {
  margin-top: 10px;
}

div.toolbar button span {
  font-size: 12px;
  font-weight: bold;
  margin-left: 5px;
}

div.toolbar button {
  margin-right: 5px;
}

.date-time-picker {
  width: 300px !important;
  margin: 0 !important;
}

.labelSeparator {
  margin-top: 10px;
}

.containerDateTime {
  padding-top: 10px;
  text-align: left;
}
</style>
